import { Link } from "react-router-dom";

// Prominent brand lockup: emblem + full company name. `size` controls scale.
export const Logo = ({ size = "md", className = "" }) => {
  const scale = {
    sm: { mark: "h-11 w-11", name: "text-lg", sub: "text-[10px]" },
    md: { mark: "h-14 w-14 sm:h-16 sm:w-16", name: "text-2xl sm:text-3xl", sub: "text-[11px] sm:text-sm" },
    lg: { mark: "h-20 w-20", name: "text-4xl sm:text-5xl", sub: "text-sm sm:text-base" },
  }[size];

  return (
    <Link
      to="/"
      data-testid="brand-logo-link"
      className={`group flex items-center gap-3 ${className}`}
      aria-label="Sharma Model Aero Engines & Propellers — Home"
    >
      <img
        src="/sharma-logo.png"
        alt="Sharma Model Aero Engines & Propellers emblem"
        className={`${scale.mark} shrink-0 object-contain transition-transform duration-500 group-hover:scale-105`}
      />
      <span className="flex flex-col leading-none">
        <span className={`font-heading font-black tracking-tight text-ink ${scale.name}`}>
          SHARMA <span className="text-saffron">MODEL AERO</span>
        </span>
        <span className={`mt-1 font-body uppercase tracking-[0.22em] text-steel ${scale.sub}`}>
          Engines &amp; Propellers · Est. 1974
        </span>
      </span>
    </Link>
  );
};
